import { SSOResponseView } from "admin/src/pages/api/v1/society/[societyId]/sso-config/[id]";
import { ApiResponse } from "admin/src/ui/types/common/api-response";
import { ApiQueryConfig } from "api";

const GetSSOResponse: ApiQueryConfig<
  ApiResponse<SSOResponseView>,
  { societyId: string; ssoConfigId: string },
  Record<string, unknown>
> = {
  apiPath: "/api/v1/society/{societyId}/sso-config/{ssoConfigId}",
  queryKey: {
    baseQueryKey: ["GetSSOResponse"],
    dynamicQueryKey: ["societyId", "ssoConfigId"],
  },
};

export { GetSSOResponse };
